package com.rosario.juridico.ui.components

import androidx.compose.animation.*
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Share
import androidx.compose.material3.*
import androidx.compose.material3.MaterialTheme.colorScheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.rosario.juridico.platform.ShareManager
import com.rosario.juridico.openUrl
import io.ktor.http.encodeURLQueryComponent
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun CajaResultadoAccionable(
    titulo: String,
    textoParaCompartir: String,
    colorFondo: Color = colorScheme.secondaryContainer,
    contenido: @Composable () -> Unit
) {
    val clipboardManager = LocalClipboardManager.current
    val scope = rememberCoroutineScope()
    var copiado by remember { mutableStateOf(false) }
    var menuCompartirExpandido by remember { mutableStateOf(false) }

    OutlinedCard(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.outlinedCardColors(containerColor = colorFondo),
        border = BorderStroke(1.dp, colorScheme.outlineVariant.copy(alpha = 0.5f))
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Text(
                text = titulo,
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.ExtraBold,
                color = colorScheme.primary,
                modifier = Modifier.padding(bottom = 8.dp)
            )

            SelectionContainer {
                Column {
                    contenido()
                }
            }

            Spacer(Modifier.height(12.dp))
            HorizontalDivider(color = colorScheme.outlineVariant.copy(alpha = 0.4f))

            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                AnimatedContent(
                    targetState = copiado,
                    transitionSpec = {
                        (fadeIn(animationSpec = tween(220, delayMillis = 90)) +
                                scaleIn(initialScale = 0.92f, animationSpec = tween(220, delayMillis = 90)))
                            .togetherWith(fadeOut(animationSpec = tween(90)))
                    },
                    label = "BotonCopiarAnimado"
                ) { isCopied ->
                    if (isCopied) {
                        TextButton(
                            onClick = { },
                            colors = ButtonDefaults.textButtonColors(contentColor = Color(0xFF4CAF50)) // Verde de éxito
                        ) {
                            Icon(Icons.Default.Check, contentDescription = "Copiado", modifier = Modifier.size(18.dp))
                            Spacer(Modifier.width(4.dp))
                            Text("¡Copiado!", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelLarge)
                        }
                    } else {
                        IconButton(onClick = {
                            clipboardManager.setText(AnnotatedString(textoParaCompartir))
                            scope.launch {
                                copiado = true
                                delay(2000)
                                copiado = false
                            }
                        }) {
                            Icon(Icons.Default.ContentCopy, "Copiar", tint = colorScheme.primary)
                        }
                    }
                }

                Box {
                    IconButton(onClick = { menuCompartirExpandido = true }) {
                        Icon(Icons.Default.Share, "Compartir", tint = colorScheme.primary)
                    }

                    DropdownMenu(
                        expanded = menuCompartirExpandido,
                        onDismissRequest = { menuCompartirExpandido = false }
                    ) {
                        DropdownMenuItem(
                            text = { Text("WhatsApp", fontWeight = FontWeight.SemiBold) },
                            onClick = {
                                menuCompartirExpandido = false
                                openUrl("https://wa.me/?text=${textoParaCompartir.encodeURLQueryComponent()}")
                            }
                        )
                        DropdownMenuItem(
                            text = { Text("Email", fontWeight = FontWeight.SemiBold) },
                            onClick = {
                                menuCompartirExpandido = false
                                openUrl("mailto:?subject=Resultado%20Jur%C3%ADdico%20Rosario&body=${textoParaCompartir.encodeURLQueryComponent()}")
                            }
                        )
                        HorizontalDivider()
                        DropdownMenuItem(
                            text = { Text("Otras opciones...") },
                            onClick = {
                                menuCompartirExpandido = false
                                ShareManager.shareText(textoParaCompartir)
                            }
                        )
                    }
                }
            }
        }
    }
}
